import React, { useEffect } from 'react';

type DateProps = {
  date: string;
};

const DateFormatter = (props: DateProps) => {
  const currentDate = new Date();
  const otherDate = new Date(props.date as string); // Replace this with the specific date and time you want to subtract

  const calculateDateTimeDifference = () => {
    const differenceInMilliseconds = currentDate.getTime() - otherDate.getTime();
    const differenceDate = new Date(differenceInMilliseconds);
    const days = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
    const hours = differenceDate.getUTCHours();
    const minutes = differenceDate.getUTCMinutes();
    const seconds = differenceDate.getUTCSeconds();
    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  useEffect(() => {
    calculateDateTimeDifference();
  }, []); // Empty dependency array to run the effect only once

  return (
    <div data-testid="date-wrapper">{`${calculateDateTimeDifference().days}d, ${
      calculateDateTimeDifference().hours
    }h, ${calculateDateTimeDifference().minutes}m, ${
      calculateDateTimeDifference().seconds
    }secs ago.`}</div>
  );
};

export default DateFormatter;
